export const TRANSLATION_KEYS = {
  fieldLabel: 'partnerbasicinfo-showrooms',
}

export const TRANSLATION_KEYS_RETAIL = {
  fieldLabel: 'partnerbasicinfo-showrooms-retail',
}
